module.exports = __webpack_public_path__ + "img/ch14_08_小破面包车.68884273.jpg";